module.exports = (__webpack_require__(4))(1790);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/core-js/library/fn/promise.js from dll-reference vendorProd_library
// module id = 658
// module chunks = 42